import { LogoOwnProps } from 'components/Shared/Logo/props';
import connect from 'components/Shared/connect';
import logo from 'assets/img/golvpoolen/logo.svg';
import logoCompany from 'assets/img/golvpoolen/logo_company.svg';
import { SiteMode } from 'models/SiteMode';
import styles from './styles.scss';
import cn from 'classnames';
import { isCheckoutPage } from 'models/CheckoutPageModel';
import { PageState } from 'models/PageState';
import { useSelector } from 'react-redux';

interface MergedProps extends LogoOwnProps {
  isCompany: boolean;
}

const Logo = ({ wrapperClassName, className, isCompany }: MergedProps) => {
  const logoUrl = isCompany ? logoCompany : logo;
  const isCheckout = useSelector(({ currentPage }: PageState) => isCheckoutPage(currentPage));
  return (
    <a className={cn(styles.logo, wrapperClassName)} href="/">
      <img
        className={cn(styles.logo, className, { [styles.isCheckoutPage]: isCheckout })}
        src={logoUrl}
      />
    </a>
  );
};

export default connect(({ appShell }) => ({
  isCompany: appShell.siteMode === SiteMode.Company
}))(Logo);
